import { Box, TextField, Typography } from '@mui/material'
import RadioSwitch from 'components/FormFields/RadioSwitch/RadioSwitch'

import { Controller, useFormContext } from 'react-hook-form'

export function ClientSettings() {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '80%',
        justifyItems: 'flex-start',
      }}
    >
      <Typography>Booking Settings</Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '25px',
          marginTop: '15px',
          justifyContent: 'flex-start',
        }}
      >
        <Controller
          name="settings.applyDestinationLogic"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Apply destination logic?'}
              />
            )
          }}
        />
        <Controller
          name="settings.applyBackupVehicleLogic"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Apply backup vehicle logic?'}
              />
            )
          }}
        />
        <Controller
          name="settings.applyFixedPricing"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Apply Fixed Pricing?'}
              />
            )
          }}
        />
        <Controller
          name="settings.automaticAllocation"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Automatically Allocate?'}
              />
            )
          }}
        />

        <Controller
          name="settings.automaticReallocation"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Automatically Re-allocate?'}
              />
            )
          }}
        />
        <Controller
          name="settings.isManaged"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Is Managed?'}
              />
            )
          }}
        />
      </Box>
      <Typography>Client Fees</Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'column',
          gap: '15px',
          justifyContent: 'space-evenly',
        }}
      >
        <Controller
          name="commission"
          control={control}
          render={({ field }) => {
            const displayValue =
              typeof field.value === 'number'
                ? String(field.value)
                : field.value
                ? String(field.value).replace(/^0+/, '')
                : ''
            return (
              <TextField
                {...field}
                type="number"
                label={'Commission %'}
                required={!!errors.commission && !!(errors.commission as any)}
                error={!!errors.commission && !!(errors.commission as any)}
                helperText={
                  errors.commission && (errors.commission as any)?.message
                }
                value={displayValue}
                onChange={(e) => {
                  const value = e.target.value.replace(/^0+/, '')
                  field.onChange(Number(value))
                }}
              />
            )
          }}
        />
        <Controller
          name="markup"
          control={control}
          render={({ field }) => {
            const displayValue =
              typeof field.value === 'number'
                ? String(field.value)
                : field.value
                ? String(field.value).replace(/^0+/, '')
                : ''
            return (
              <TextField
                {...field}
                type="number"
                label={'Markup %'}
                required={!!errors.markup && !!(errors.markup as any)}
                error={!!errors.markup && !!(errors.markup as any)}
                helperText={errors.markup && (errors.markup as any)?.message}
                value={displayValue}
                onChange={(e) => field.onChange(Number(e.target.value))}
              />
            )
          }}
        />
      </Box>
      {/* <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'column',
          gap: '15px',
          justifyContent: 'space-evenly',
        }}
      >
        <Typography>Customisation</Typography>
        <Accordion>
          <AccordionSummary
            expandIcon={
              <KeyboardArrowDown sx={{ color: 'white !important' }} />
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              backgroundColor: 'var(--jy-navy-900, #00253d)',
              color: 'white !important',
              overflow: 'none',
              borderRadius: '4px',
            }}
          >
            <Typography>Application Theme</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <p>Additional Settings</p>
            <p>Additional Settings</p>
            <p>Additional Settings</p>
            <p>Additional Settings</p>
          </AccordionDetails>
        </Accordion>
      </Box> */}
    </Box>
  )
}
